module.exports = __webpack_public_path__ + "img/choiceIcon.07481313.svg";